import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero';
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import About from '../../components/about/about';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import FunFact from '../../components/FunFact/FunFact';
import Testimonial from '../../components/Testimonial/Testimonial';
import PartnerSection from '../../components/PartnerSection/PartnerSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'
import SEO from '../../components/Seo';
import { useEffect } from 'react';
import { initLeadPopup } from '../../utils/leadPopup';
import ContactForm from '../../components/ContactFormSection/ContactFormSection';


const HomePage = () => {
    useEffect(() => {
        initLeadPopup();
    }, []);
    return (
        <Fragment>
            <SEO
                title="LuxRock Realty | Buy & Sell Property with Trusted Experts"
                description="Explore verified residential & commercial properties with LuxRock Realty. We help you find your dream property with safe and transparent deals."
                keywords="property in surat, real estate surat, buy flat in surat, commercial property surat, LuxRock Realty"
            />
            <Navbar hclass={'wpo-site-header wpo-header-style'} Logo={Logo} col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-4 col-md-6 col-6'}
                col3={'col-lg-6 col-md-1 col-1'}
                col4={'col-lg-2 col-md-2 col-2'} />
            <Hero />
            <ScrollTextAnimation />
            <About hclass={"wpo-about-section section-padding pb-0"} />
            <ProjectSection hclass={'wpo-project-section section-padding'} />
            <ServiceSection hclass={'wpo-service-section'} />
            <FunFact hclass={'wpo-funfact-section'} />
            <Testimonial hclass={'wpo-testimonial-section'} />

            {/* <TeamSection hclass={'wpo-team-section'} /> */}
            <PartnerSection hclass={'wpo-partners-section fade_bottom'} />
            <Footer />
            <Scrollbar />
            <div id="leadPopup" className="lead-overlay">
                <div className="lead-modal">
                    <button id="leadClose" className="lead-close">×</button>

                    <h3 className="popup-title">Get Free Property Consultation</h3>

                 <ContactForm/>
                </div>
            </div>
        </Fragment>
    )
}

export default HomePage